import { Controller } from '@hotwired/stimulus';

// 支払い済み給与の編集確認モーダル (#2688)。
// 「編集する」と歯車メニューの「マニュアルで編集」で遷移先が異なるため、
// モーダルを開いたトリガの data-paid-edit-url を進むボタンの href へ移す。
// トリガ側に URL が無い場合はサーバーが描画した既定の href をそのまま使う。
export default class extends Controller {
  static targets = ['proceed'];

  connect() {
    this.defaultUrl = this.hasProceedTarget ? this.proceedTarget.getAttribute('href') : null;
    this.onShow = this.onShow.bind(this);
    this.element.addEventListener('show.bs.modal', this.onShow);
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.onShow);
  }

  onShow(event) {
    if (!this.hasProceedTarget) { return; }

    const trigger = event.relatedTarget;
    const url = trigger && trigger.dataset ? trigger.dataset.paidEditUrl : null;
    this.proceedTarget.setAttribute('href', url || this.defaultUrl);
  }
}
